var BaseProperty = require("../BaseProperty");

module.exports = (function () {

	var o = function (graph) {
		BaseProperty.apply(this, arguments);

		var that = this,
			superDrawFunction = that.draw,
			label = "Клон"; //

		this.draw = function (labelGroup) {
			that.labelVisible(false); //!graph.options().compactNotation()
			return superDrawFunction(labelGroup);
		};

		// Disallow overwriting the label
		this.label = function (p) {
			if (!arguments.length) return label;
			return this;
		};

		this.linkType("dotted")
			.markerType("white")
			.styleClass("subclass")
			.type("CloneNode");
    };
	o.prototype = Object.create(BaseProperty.prototype);
	o.prototype.constructor = o;

	return o;
}());
